import React, { Component } from 'react';
import { Button, TextField, Container, Grid, Card } from '@material-ui/core/';
import { SetNewPassword, LoginSetErrors } from '../actions';
import { connect } from 'react-redux';
import OverLoader from './common/loader';
import isEmpty from 'lodash.isempty';
import {
  Redirect
} from "react-router-dom";

class ForgotPassword extends Component {

  state = {
    password: '',
    passwordConfirmation: '',
    isForgotPassword: false,
    forgotEmail: '',
    forgotError: false,
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.listener);
  }
  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.listener);
  }

  listener = event => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      this.handleSubmit()
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.forgot_success === true)
      this.setState({ isForgotPassword: false })
    if (nextProps.forgot_error !== this.props.forgot_error)
      this.setState({ forgotError: nextProps.forgot_error })
  }

  handleSubmit = () => {
    const { passwordConfirmation, password } = this.state
    if (!password)
      this.props.LoginSetErrors("username", true);
    if (!passwordConfirmation)
      this.props.LoginSetErrors("password", true);
    if (passwordConfirmation !== "" && password !== "") {
      this.props.SetNewPassword(password, passwordConfirmation)
    }
  }
  render() {
    const { forgot_success_message, login_server_error, login_errors } = this.props
    const { forgotError } = this.state
    return (
      <Container>
        {this.props.loading && <OverLoader />}
        <Grid className="text-center">
          <br />
          <br />
          <h5>Willkommen beim Lipro-System 4.0</h5>
          <h3>Lischke Consulting GmbH</h3>
          <br />
          <Card className="p-40">
            <div className="flex-center">

              <div className="w-150">Neues Kennwort</div>

              <TextField type="password" error={login_errors.username || !isEmpty(forgotError.password)}
                helperText={!isEmpty(forgotError.password) ? forgotError.password : ''}
                required className="w-150" label=""
                onChange={(e) => {
                  this.props.LoginSetErrors("username", false);
                  if (forgotError.password)
                    forgotError.password = ''
                  this.setState({ password: e.target.value, missMatch: false })
                }} />

            </div>

            <br />

            <div className="flex-center">

              <div className="w-150">Kennwortbestätigung</div>
              <TextField error={login_errors.password || !isEmpty(forgotError.password_confirmation)} type="password"
                helperText={!isEmpty(forgotError.password_confirmation) ? forgotError.password_confirmation : ''}
                required className="w-150" label="" onChange={(e) => {
                  this.props.LoginSetErrors("password", false);
                  if (forgotError.password_confirmation)
                    forgotError.password_confirmation = ''
                  this.setState({ passwordConfirmation: e.target.value, missMatch: false })
                }} />

            </div>
            <br />

            <div className="h-50">
              {
                login_server_error &&
                <small className="text-red">{this.props.http_error.status} {this.props.http_error.status_text}: {this.props.http_error.message}</small>
              }
            </div>
          </Card>

          <br />
          {forgot_success_message && <div>
            <Redirect to="/login" />
          </div>}
          <br />

          <Button type="submit" onClick={this.handleSubmit} variant="outlined" color="primary" className="m-10">Anmelden</Button>

        </Grid>
      </Container>
    )

  }
}

const mapStateToProps = state => {
  const { user, forgot_success, forgot_success_message, forgot_error, login_form, login_errors, login_server_error, http_error, loading } = state.login;
  return {
    user,
    forgot_success,
    login_form,
    login_errors,
    login_server_error,
    http_error,
    forgot_error,
    forgot_success_message,
    loading
  }
}

export default connect(
  mapStateToProps,
  {
    SetNewPassword,
    LoginSetErrors
  }
)(ForgotPassword)